import { render } from "./ProfileInfoTab.vue?vue&type=template&id=0a72ca26&scoped=true&ts=true"
import script from "./ProfileInfoTab.vue?vue&type=script&lang=ts"
export * from "./ProfileInfoTab.vue?vue&type=script&lang=ts"

import "./ProfileInfoTab.vue?vue&type=style&index=0&id=0a72ca26&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a72ca26"]])

export default __exports__